<template>
  <Short_Header_AS />

  <!-- Works Banner -->
  <section>
    <div class="banner-home-header">
      <div class="container">
        <div
          loading="lazy"
          class="img-banner-home-header"
          :style="{
            backgroundImage: `url(${require('@/assets/talento_agv/img/banner-7.png')})`,
          }"
        ></div>
      </div>

      <div class="sobrefondo"></div>

      <img
        class="certificado-badge"
        src="@/assets/talento_agv/img/home/Certificado-Sep-2024-2025.png"
        alt="Certificado"
      />
    </div>
  </section>

  <section>
    <div class="container p-4">
      <div v-if="dialogLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-3">Cargando...</div>
      </div>
      <DetailJob_AS v-else :initial-job-data="jobOfferDetails" />
    </div>
  </section>
  <div class="section-footer-detail-job"></div>
  <!-- Footer -->
  <Footer_AS />
</template>
<script>
import axiosIns from "@/plugins/axios.js";
import Footer_AS from "./components/Footer_AS.vue";
import Short_Header_AS from "./components/Short_Header_AS.vue";
import DetailJob_AS from "./components/DetailJob_AS.vue";
export default {
  components: {
    Footer_AS,
    Short_Header_AS,
    DetailJob_AS,
  },
  data() {
    return {
      id_joboffer: null,
      jobOfferDetails: [],
      dialogLoading: true,
    };
  },
  mounted() {
    this.id_joboffer = this.$route.query.id;
    this.getJobOffers();
  },
  methods: {
    async getJobOffers() {
      const yo = this;
      const config = {
        method: "get",
        url: "/talentoagv/readJobOffers/",
      };
      yo.dialogLoading = true;

      await axiosIns(config)
        .then(function (response) {
          if (response.data["is_error"] === false) {
            let resultado = response.data["result"];
            for (let r of resultado) {
              if (r["id"] == yo.id_joboffer) {
                yo.jobOfferDetails = r;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data["message"], "Error");
        })
        .finally(function () {
          yo.dialogLoading = false;
        });
    },
  },
};
</script>
<style scoped src="./styles/shared_AS.css"></style>
<style scoped src="./styles/detalle_oferta_laboral_AS.css"></style>
